import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

function Card({ title, body, isLocked }) {
  return (
    <div className="b-card-container">
      {isLocked && (
        <div className="b-card-container__locked-child">
          <Typography className="font-bold b-card-container__locked-title">
            {title}
          </Typography>
        </div>
      )}
      {!isLocked && (
        <div className="b-card-container__child">
          <Typography className="font-bold b-card-container__title">
            {title}
          </Typography>
        </div>
      )}

      <div className="b-card-container__body">{body}</div>
    </div>
  );
}
Card.propTypes = {
  title: PropTypes.string.isRequired,
  // body: PropTypes.number.isRequired,
  body: PropTypes.node.isRequired,
  // isLocked: PropTypes.string.isRequired,
  isLocked: PropTypes.bool.isRequired,
};

export default Card;
